import { render, staticRenderFns } from "./organization-user-details.html?vue&type=template&id=388c6be0&scoped=true&"
import script from "./organization-user-details.js?vue&type=script&lang=js&"
export * from "./organization-user-details.js?vue&type=script&lang=js&"
import style0 from "./organization-user-details.scss?vue&type=style&index=0&id=388c6be0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388c6be0",
  null
  
)

export default component.exports